import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Listing.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const CommercialListing = () => {
  const [commercialListings, setCommercialListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const startTime = Date.now();

    const fetchListings = async () => {
      try {
        const response = await fetch(
          "https://t3yaaqetsktr267ko4xucsactu0wdogd.lambda-url.us-east-2.on.aws/",
          {
            headers: { "x-custom-key": "crazySecretKey82183b48921$@^JNF@!" },
          }
        );
        const data = await response.json();

        let allListings = [];
        if (Array.isArray(data)) {
          allListings = data;
        } else if (data.listings && Array.isArray(data.listings)) {
          allListings = data.listings;
        }

        const onlyCommercial = allListings.filter(
          (l) =>
            l.Unit?.Description?.startsWith("Commercial:") ||
            l.Property?.StructureDescription?.startsWith("Commercial:")
        );

        setCommercialListings(onlyCommercial);

        const elapsed = Date.now() - startTime;
        const remaining = 2000 - elapsed;

        if (remaining > 0) {
          setTimeout(() => setLoading(false), remaining);
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching listings:", error);
        setCommercialListings([]);

        const elapsed = Date.now() - startTime;
        const remaining = 2000 - elapsed;

        if (remaining > 0) {
          setTimeout(() => setLoading(false), remaining);
        } else {
          setLoading(false);
        }
      }
    };

    fetchListings();
  }, []);

  const cleanDescription = (desc = "") =>
    desc.replace(/^Commercial:/, "").trim() || "N/A";

  const formatDate = (dateValue) => {
    if (!dateValue) return "N/A";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;
    return date.toLocaleDateString();
  };

  const formatCurrency = (value) => {
    if (!value) return "N/A";
    return `$${Number(value).toLocaleString()}`;
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Helmet>
          <title>For Rent Commercial Properties | Harrisburg, PA</title>
          <meta
            name="description"
            content="Commercial Properties in the Harrisburg Pennsylvania Area."
          />
          <link
            rel="canonical"
            href="https://www.deltapmg.com/commercial-listings"
          />

          <meta
            property="og:title"
            content="For Rent Commercial Properties | Harrisburg, PA"
          />
          <meta
            property="og:description"
            content="Commercial Properties in the Harrisburg Pennsylvania Area."
          />
          <meta
            property="og:url"
            content="https://www.deltapmg.com/commercial-listings"
          />
          <meta property="og:type" content="website" />
        </Helmet>

        <div className="loading-content">
          <div className="loading-spinner-wrapper">
            <div className="loading-spinner"></div>
            <div className="loading-pulse"></div>
          </div>
          <h2 className="loading-title">Loading Listings...</h2>
          <p className="loading-subtitle">
            Fetching available properties
          </p>
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="listing-container">
      {commercialListings.length === 0 ? (
        <div>
        <p className="no-listings-1">Currently Fully Leased — New Rentals Coming Soon</p>
          <div className="listing-preference-cta">
                <Link
                  to="/listing-preferences"
                  className="listing-preference-btn"
                >
                  Submit Rental Preferences
                </Link>
            </div>  
          </div>
      ) : (
        <>
          <h1 className="listing-title-1">Commercial Listings:</h1>

          {commercialListings.map((listing, index) => {
            const unit = listing.Unit || {};
            const property = listing.Property || {};

            const image =
              unit.Files?.find((f) => f.Type === "Image")?.Url ||
              property.Files?.find((f) => f.Type === "Image")?.Url ||
              "https://via.placeholder.com/150";

            const address = `${unit.Address?.AddressLine1 || property.Address?.AddressLine1 || ""}, ${
              unit.Address?.City || property.Address?.City || ""
            }, ${unit.Address?.State || property.Address?.State || ""} ${
              unit.Address?.PostalCode || property.Address?.PostalCode || ""
            }`;

            const rentalUrl = listing.RentalApplicationUrl || "";
            const urlParams = new URLSearchParams(rentalUrl.split("?")[1] || "");
            const listingId = urlParams.get("listingId");

            return (
              <div
                key={index}
                className="listing-card"
                onClick={() =>
                  navigate(`/commercial-listings/${listingId}`, {
                    state: { listing },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <div className="listing-image">
                  <img src={image} alt={address} loading="lazy" />
                </div>

                <div className="listing-details">
                  <h3>{address}</h3>
                  <p>
                    <strong>Sqft:</strong> {unit.UnitSize || "N/A"}
                  </p>
                  <p className="listing-description">
                    <strong>Description:</strong>{" "}
                    {cleanDescription(unit.Description) ||
                      cleanDescription(property.StructureDescription)}
                  </p>
                  <p>
                    <strong>Price:</strong> {formatCurrency(listing.Rent)}
                  </p>
                  <p>
                    <strong>Available Date:</strong>{" "}
                    {formatDate(listing.AvailableDate)}
                  </p>
                </div>
              </div>
            );
          })}
          <div className="listing-preference-cta">
              <h2>Didn&apos;t find what you are looking for?</h2>
              <Link
                to="/listing-preferences"
                className="listing-preference-btn"
              >
                Submit Rental Preferences
              </Link>
          </div>         
        </>
      )}
    </div>
  );
};

export default CommercialListing;